// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_gridItems_v2", inline: true, disabled: false };
const msgs = {
  start: ["init. gridItems_v2"],
  end: ["init. gridItems_v2", "init. success"],
  no_el: ["init. gridItems_v2", "no valid DOM el. provided"],
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_gridItems_v2() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { gridItems } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);
  if (gridItems === undefined) return this.cancel_featInit(msgs.no_el);
  if (gridItems.every((el) => !this.validate_refEl(el))) return this.cancel_featInit(msgs.no_el);

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Grid item click hdl. //
  gridItems.forEach((item) => {
    // Active grid item state updt. //
    item.addEventListener("click", () => {
      const is_active = item.dataset.id == this.state.activeGridItem;
      if (is_active) return;
      this.setState({ activeGridItem: item.dataset.id != this.state.activeGridItem ? item.dataset.id : "null" });
    });
  });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
